import script from "./QAAUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./QAAUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./QAAUpsert.vue?vue&type=style&index=0&id=e431f37c&lang=scss"

const __exports__ = script;

export default __exports__